interface ObjectWithId {
    id: number;
}
export const filterUnique = (arr: ObjectWithId[]) => {
    return [
        ...arr
            .reduce((acc, val) => {
                acc.set(val.id, val);
                return acc;
            }, new Map())
            .values(),
    ];
};

export const getImageUrl = (image: string) =>
    `https://firebasestorage.googleapis.com/v0/b/networknerd-4aa62.appspot.com/o/profile%2F${image}?alt=media`;

const MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "Octomber",
    "November",
    "December",
];
export const formatDate = (date: string): string => {
    if (!date) return "";
    const dateSplit = date.split("#");
    if (dateSplit.length === 1) {
        const dateObject = new Date(date);
        return `${MONTHS[dateObject.getMonth()]} ${dateObject.getDay()}`;
    } else if (dateSplit.length === 2) {
        return `${MONTHS[parseInt(dateSplit[1])]} ${
            parseInt(dateSplit[0]) + 1
        }`;
    } else {
        return `${MONTHS[parseInt(dateSplit[1])]} ${
            parseInt(dateSplit[0]) + 1
        }, ${dateSplit[2]}`;
    }
};
function fallbackCopyTextToClipboard(text: string) {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
    } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
    }

    document.body.removeChild(textArea);
}
export function copyTextToClipboard(text: string) {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).then(
        function () {},
        function (err) {
            console.error("Async: Could not copy text: ", err);
        }
    );
}
